/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Link = (function () {

    function Link () {

        Monet.UI.Fields.TextField.apply (this, arguments);

        this.createBaseStructure ();

        this.input = null;
        this.value = false;
        this.action = false;
        this.customJavaScript = null;

        var baseElement = null;

        this.setCustomJavaScript = function (customJavaScript) {
           this.customJavaScript = customJavaScript || this.customJavaScript;
           if(this.input){
               this.input.href = this.customJavaScript;
           }
        };

        this.createElement = function () {
            if(!baseElement){
                this.input = document.createElement ('a');
                this.input.id = 'link_'+ this.name;
                this.input.className = 'MonetUIFieldLink';
                this.input.setAttribute('name', this.name);

                if(this.meta){
                    this.entity = this.meta.entity || this.entity ;
                    this.customJavaScript = this.meta.customJavascript || this.customJavaScript ;
                }

                this.input.setAttribute('entity', this.entity);

                this.setInputValue();
                this.setCustomJavaScript();

                baseElement = this.input;

                this.rootEl.appendChild(this.input);
            }

        };

        this.render = function () {

            this.createElement();
            this.setInputValue();
            return this.rootEl;

        };

        this.setValue = function (value) {
            this.value = value || this.value;
            this.setInputValue();
        };

        this.setInputValue = function () {
            if(this.input) {
                this.input.innerHTML = Monet.I18n.getResourcesByKey(this.value || this.defaultValue);
            }
        };

        this.clear = function () {
        };
    }

    return Link;

}());